import type {
  Ability,
  CharacterStats,
  MovementStats,
} from '../../CharacterTypes';

export const MAGE_CONFIG = {
  name: 'Astromancer',
  description: 'Powerful spellcaster with ranged damage and crowd control',
  baseStats: {
    strength: 7,
    dexterity: 8,
    intelligence: 16,
    luck: 15,
    attack: 18,
    magicAttack: 25,
    defense: 6,
    magicDefense: 15,
    criticalRate: 0.08
  } as CharacterStats,
  healthMultiplier: 0.8,
  manaMultiplier: 1.4,
  color: '#4169E1',
  movementStats: {
    jumpPower: 1100,
    targetJumpHeight: 200,
    moveSpeed: 300,
    gravityScale: 0.9,
    terminalVelocity: 1000,
    acceleration: 3000,
    deceleration: 6000
  } as MovementStats,
  abilities: [
    {
      id: 'mage_auto',
      name: 'Arcane Bolt',
      damage: 10,
      manaCost: 0,
      cooldown: 600,
      lastUsed: 0,
      range: 500,
      castTime: 0,
      description: 'Basic arcane bolt — quick ranged auto attack.',
      icon: '/icons/arcane_bolt.svg'
    },
    {
      id: 'fireball',
      name: 'Fireball',
      damage: 50,
      manaCost: 0,
      cooldown: 500,
      lastUsed: 0,
      range: 600,
      castTime: 0,
      description: 'Launch a massive, homing fireball at the enemy.',
      icon: '/icons/fire_ball.svg'
    },
    {
      id: 'arcane_barrage',
      name: 'Arcane Barrage',
      damage: 8,
      manaCost: 25,
      cooldown: 4000,
      lastUsed: 0,
      range: 600,
      castTime: 0,
      description: 'Launch a barrage of 7 arcane bolts',
      icon: '/icons/arcane_barrage.svg'
    },
    {
      id: 'blink',
      name: 'Blink',
      damage: 0,
      manaCost: 15,
      cooldown: 2000,
      lastUsed: 0,
      range: 300,
      castTime: 0,
      description: 'Teleport a short distance in the facing direction.',
      icon: '/icons/dev_teleport.svg'
    },
    {
      id: 'mana_shield',
      name: 'Mana Shield',
      damage: 0,
      manaCost: 25,
      cooldown: 25000,
      lastUsed: 0,
      range: 0,
      castTime: 0,
      description: 'Absorb damage with mana',
      icon: '/icons/mana_shield.svg'
    }
  ] as Ability[]
};
